import React from "react";

import { classNames } from "../../../../utils/classNames";

type HeadlineProps = {
    rank: 1 | 2 | 3 | 4 | 5 | 6;
    className?: string;
};

export const Headline: React.FC<React.PropsWithChildren<HeadlineProps>> = ({ rank, className, children }) => {
    const Tag = `h${rank}` as keyof JSX.IntrinsicElements;
    let baseClassName = "text-neutral-900 ";

    switch (rank) {
        case 1:
            baseClassName += "font-bold text-3xl sm:text-4xl";
            break;
        case 2:
            baseClassName += "font-semibold text-2xl sm:text-3xl";
            break;
        case 3:
            baseClassName += "font-semibold text-xl sm:text-2xl";
            break;
        case 4:
            baseClassName += "font-semibold text-lg sm:text-xl";
            break;
        case 5:
            baseClassName += "font-semibold text-md sm:text-lg";
            break;
        case 6:
            baseClassName += "font-semibold text-base sm:text-md";
            break;
        default:
            baseClassName += "font-semibold text-sm sm:text-base";
    }

    return <Tag className={classNames(baseClassName, className)}>{children}</Tag>;
};
